import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "Redux/actions";
import { clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    drivers: []
};

const route = 'modules/driverPerformance/views/driver/modals/shareDriver/redux/slice';

export const shareDriver = createAsyncThunk(
    "driverPerformance/driver/shareDriver/bulkCreateDriverPerformanceCasesFull",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const response = await clientMutation(
                ``,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
           /*  return response?.data; */
        } catch (exc) {
            ExceptionManager(exc, route, "shareDriver");
            return rejectWithValue(exc);
        }
    }
);

//Slice
const driverPerformanceDriverTabShareDriverRedux = createSlice({
    name: "driverPerformance/shareDriver",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalShareDriver: (state, action) => {
            state.open = action.payload.open;
            state.drivers = action?.payload?.drivers || []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(shareDriver.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(shareDriver.fulfilled, (state, action) => {
            state.loading = false;
            state.coaches = action.payload;
        });
        builder.addCase(shareDriver.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceDriverTabShareDriverRedux;

// Extract and export each action creator by name
export const { openModalShareDriver, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
